import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { tPatientService } from 'src/app/services/tPatient.service';

@Component({
  selector: 'app-patient-mailing-label',
  templateUrl: './patient-mailing-label.component.html',
  styleUrls: ['./patient-mailing-label.component.css']
})
export class PatientMailingLabelComponent implements OnInit {

  @Input() patientID: string;

  patient = {
    patientID:"97854",
    name:"陳大文",
    surname:"Lau Fong Yuen",
    dob:"dd/mm/yyyy",
    hkid:"C12345679",
    hkidDesc:"HKID",
    registeredDate:"dd/mm/yyyy",
    caseDrID:"WL",
    gender:"F",
    age:"30",
    address:"1 a dsd\n2sdd asd\n3sadasdw wqwe"
  };

  constructor(
    public activeModal: NgbActiveModal,
    private patientService : tPatientService,
    private crypService: CrypService,

  ) { }

  ngOnInit() {
    this.initPatientInfo();
  }

  initPatientInfo(){
    this.patientService.getLabelPrint(this.patientID,2).subscribe(x=>{
      this.patient = x.data;
      this.patient.hkid = this.crypService.decryptStr(this.patient.hkid).toString();
    })
  }

}
